// reducers.js
import {
    CLEAR_SHOW_MORE_COLLECTION_LIST,
    CLEAR_SHOW_MORE_PRODUCT_LIST,
    FETCH_BANNER,
    FETCH_DRAWER_MENU,
    FETCH_LATEST_VERSION,
    FETCH_PRODUCT_LIST, FETCH_PRODUCT_MODAL_DATA_LIST, FETCH_SHOW_MORE_COLLECTION_LIST, FETCH_SHOW_MORE_PRODUCT_LIST,
    SET_BANNER,
    SET_DRAWER_MENU, SET_PRODUCT_LIST, SET_PRODUCT_MODAL_DATA_LIST, SET_SHOW_MORE_COLLECTION_LIST, SET_SHOW_MORE_PRODUCT_LIST
} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    showMoreCollectionData: null,
    isLoading: false,
    error: null,
};

const showMoreCollectionDataReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_SHOW_MORE_COLLECTION_LIST:
            return {
                ...state,
            };

        case SET_SHOW_MORE_COLLECTION_LIST:
            return {
                ...state,
                showMoreCollectionData: action.payload,
                isLoading: false,
            };

        case CLEAR_SHOW_MORE_COLLECTION_LIST:
            return {
                ...state,
                showMoreCollectionData: null,
            };

        default:
            return state;
    }
};

export default showMoreCollectionDataReducer;
